import { SeznamRegistraci } from '../../common/aresTypes'

const registryMeta: {
  key: keyof SeznamRegistraci
  shortcut: string
  register: string
  url: (ico?: string) => string
}[] = [
  {
    key: 'stavZdrojeVr',
    shortcut: 'VR',
    register: 'Veřejný rejstřík',
    url: ico =>
      `https://or.justice.cz/ias/ui/rejstrik-$firma?ico=${ico}&jenPlatne=VSECHNY`,
  },
  {
    key: 'stavZdrojeRes',
    shortcut: 'RES',
    register: 'Registr ekonomických subjektů',
    url: ico => `https://ares.gov.cz/ekonomicke-subjekty/res/${ico}`,
  },
  {
    key: 'stavZdrojeRzp',
    shortcut: 'RŽP',
    register: 'Živnostenský rejstřík',
    url: ico => `https://www.rzp.cz/cgi-bin/portal.cgi?ICO=${ico}`,
  },
  {
    key: 'stavZdrojeNrpzs',
    shortcut: 'NRPZS',
    register: 'Národní registr poskytovatelů zdravotních služeb',
    url: ico =>
      `https://nrpzs.uzis.cz/index.php?q=${ico}&pg=vyhledavani-poskytovatele--pro-verejnost`,
  },
  {
    key: 'stavZdrojeRpsh',
    shortcut: 'PSH',
    register: 'Seznam politických stran a hnutí',
    url: () => `https://aplikace.mvcr.cz/seznam-politickych-stran/Default.aspx`,
  },
  {
    key: 'stavZdrojeRcns',
    shortcut: 'RCNS',
    register: 'Registr církví a náboženských společností',
    url: ico => `https://ares.gov.cz/ekonomicke-subjekty/rcns/${ico}`,
  },
  {
    key: 'stavZdrojeSzr',
    shortcut: 'EZP',
    register: 'Evidence zemědělského podnikatele',
    url: ico => `https://eagri.cz/public/app/SZR/EZP/ezpPortal/Detail/${ico}`,
  },
  {
    key: 'stavZdrojeDph',
    shortcut: 'DPH',
    register: 'Registr plátců DPH',
    url: ico =>
      `https://adisspr.mfcr.cz/dpr/DphReg?id=1&pocet=1&fu=&OK=+Search+&ZPRAC=RDPHI1&dic=CZ${ico}`,
  },
  {
    key: 'stavZdrojeSd',
    shortcut: 'SD',
    register: 'Registr plátců spotřební daně',
    url: ico =>
      `https://www.celnisprava.cz/cz/aplikace/Stranky/SpdInternet.aspx?act=findspd&dic=${ico}&lang=cz`,
  },
  {
    key: 'stavZdrojeIr',
    shortcut: 'IR',
    register: 'Insolvenční rejstřík',
    url: ico =>
      `https://isir.justice.cz/isir/ueu/vysledek_lustrace.do?ic=${ico}&aktualnost=AKTUALNI_I_UKONCENA`,
  },
  {
    key: 'stavZdrojeCeu',
    shortcut: 'CEU',
    register: 'Centrální evidence úpadců',
    url: ico => `https://upadci.justice.cz/p_i6.php?ico=${ico}&MAXPOC=50`,
  },
  {
    key: 'stavZdrojeRs',
    shortcut: 'RŠ',
    register: 'Rejstřík škol a školských zařízení',
    url: ico => `https://ares.gov.cz/ekonomicke-subjekty/rs/${ico}`,
  },
  {
    key: 'stavZdrojeRed',
    shortcut: 'RED',
    register: 'Centrální registr dotací',
    url: ico =>
      `https://red.financnisprava.cz/registr-dotaci/prijemci?ic=${ico}`,
  },
  {
    key: 'stavZdrojeMonitor',
    shortcut: 'MON',
    register: 'Monitor (monitor.statnipokladna.cz)',
    url: ico => `https://monitor.statnipokladna.cz/ucetni-jednotka/${ico}`,
  },
]

export const getAresSeznamRegistraci = (
  ico?: string,
  seznamRegistraci?: SeznamRegistraci
) => {
  if (!ico || !seznamRegistraci) return []

  const rows = registryMeta.map(meta => {
    const state = seznamRegistraci?.[meta.key] || 'NEEXISTUJICI'
    return {
      key: meta.key,
      shortcut: meta.shortcut,
      register: meta.register,
      url: meta.url(ico),
      state,
    }
  })

  return rows.sort((a, b) => {
    const alphabetSort = a.register.localeCompare(b.register, 'cs', {
      sensitivity: 'base',
    })
    if (alphabetSort !== 0) return alphabetSort

    const aMissing = a.state === 'NEEXISTUJICI'
    const bMissing = b.state === 'NEEXISTUJICI'
    if (aMissing === bMissing) return 0
    return aMissing ? 1 : -1
  })
}
